import React from "react";
import GitchaConsumerTag from "@/components/GitchaConsumerTag";
import { initialsOf, shortTime, toneOf } from "@/components/Inbox/inboxModel";
import IntroRowActions from "./IntroRowActions";
import "./InboxRow.scss";

export const Avatar = ({ name, photo, size = 44 }) => (
  <span className={`inbox-avatar is-tone-${toneOf(name)}`} style={{ width: size, height: size }} aria-hidden="true">
    {photo ? <img src={photo} alt="" loading="lazy" /> : initialsOf(name)}
  </span>
);

const Row = ({ row, selected, onSelect }) => (
  <li className={`inbox-row${selected ? " is-selected" : ""}${row.unread ? " is-unread" : ""}`}>
    <button
      type="button"
      className="inbox-row__hit"
      aria-current={selected ? "true" : undefined}
      onClick={() => onSelect(row)}
    >
      <Avatar name={row.name} photo={row.photo} />
      <span className="inbox-row__body">
        <span className="inbox-row__top">
          <span className="inbox-row__name">
            {row.name}
            {row.kind === "direct" ? <GitchaConsumerTag person={row.chat} /> : null}
          </span>
          <time className="inbox-row__time">{shortTime(row.time)}</time>
        </span>
        <span className="inbox-row__context">{row.context}</span>
        <span className="inbox-row__preview">
          {row.awaitingReply ? "Waiting for a reply" : row.preview}
          {row.unread ? <span className="inbox-row__dot" aria-label="Unread" /> : null}
        </span>
      </span>
    </button>
    {row.kind === "intro" && row.direction === "received" ? (
      <IntroRowActions intro={row.intro} name={row.name} otherUserId={row.intro.inventroyCreatedId} />
    ) : null}
  </li>
);

export default Row;
